const store = {
    namespaced: true,
    state() {
        return {
            mainBrands: [],
            mainBrandsIsLoading: false,
        };
    },
    getters: {
        getMainBrands: state => state.mainBrands,
        getMainBrandsIsLoading: state => state.mainBrandsIsLoading,
        getFeaturedBrands: state => {
            return state.mainBrands.slice(0, 12);
        },
        getBrandsByAlphabet: state => {
            const grouped = {};
            state.mainBrands.forEach(brand => {
                const firstLetter = brand.name[0].toUpperCase();
                let key = firstLetter;
                if (/^[1-9]$/.test(firstLetter)) {
                    key = '1';
                }
                if (!grouped[key]) {
                    grouped[key] = {
                        name: key,
                        items: [],
                    };
                }
                grouped[key].items.push(brand);
            });
            // Сортировка по алфавиту, "1" всегда первая
            return Object.values(grouped).sort((a, b) => {
                if (a.name === '1') return -1;
                if (b.name === '1') return 1;
                return a.name.localeCompare(b.name);
            });
        },
    },
    mutations: {
        SET_MAIN_BRANDS: (state, data) => (state.mainBrands = data),
        SET_MAIN_BRANDS_IS_LOADING: (state, value) => (state.mainBrandsIsLoaded = value),
    },
    actions: {
        async fetchMainBrands({ commit }) {
            commit('SET_MAIN_BRANDS_IS_LOADING', true);
            try {
                const data = await this.$axios.$get('general/brand');
                commit('SET_MAIN_BRANDS', data);
                // }
            } catch (error) {
                console.error('Error fetching main page similar category:', error);
            } finally {
                commit('SET_MAIN_BRANDS_IS_LOADING', false);
            }
        },
    },
};

export default store;
